'use strict';

require('../js-handler/start-app')
require('./back-control')
require('./change')
require('./click')
require('./click-double')
require('./click-right')
require('./key')
require('./key-down')
require('./load')
require('./scroll')
require('./touch')
require('./drop')

//require('./components/graph/pie-simple')